export default "__VITE_ASSET__BkFsz_Hy__"